import { ConversationStatusVoData } from "./conversation-status-vo-data";
import { ConversationVisibilityVoData } from "./conversation-visibility-vo-data";
import { ConversationStateVoData } from "./conversation-state-vo-data";
var ConversationVoData = /** @class */ (function () {
    function ConversationVoData(jabberId) {
        this.uid = jabberId;
        this.visibility = ConversationVisibilityVoData.PUBLIC;
        this.status = ConversationStatusVoData.OPEN;
        this.usersStatictics = [];
        this.messagesId = [];
        this.read = false;
        this.state = ConversationStateVoData.NOT_SEND;
    }
    return ConversationVoData;
}());
export { ConversationVoData };
//# sourceMappingURL=conversation-vo-data.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/vo/chat/conversation-vo-data.js
// module id = 921
// module chunks = 14